/** Legacy stable ids — one per attempt caused duplicate keys in long conversations. */
export const LEGACY_PROJECTED_USER_QUESTION_ID =
  "qualification-user-question" as const;
export const LEGACY_PROJECTED_ASSISTANT_ANSWER_ID =
  "qualification-assistant-answer" as const;

export function projectedUserQuestionId(attemptId: string): string {
  return `qualification-user-question-${attemptId}`;
}

export function projectedAssistantAnswerId(attemptId: string): string {
  return `qualification-assistant-answer-${attemptId}`;
}

export function createQualificationAttemptId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
